import type { PlaybackMediaType } from './types';

export function normalizePlaybackMediaType(value?: string | null): PlaybackMediaType | undefined {
  const type = value?.split(';', 1)[0].trim().toLowerCase();
  if (['mp4', 'self_hosted_mp4', 'video/mp4', 'application/mp4'].includes(type || '')) return 'mp4';
  if (['hls', 'm3u8', 'application/vnd.apple.mpegurl', 'application/x-mpegurl'].includes(type || '')) return 'hls';
  return undefined;
}

export function inferPlaybackMediaType(source: string, hint?: PlaybackMediaType): PlaybackMediaType {
  if (hint) return hint;
  try {
    const pathname = new URL(source, 'https://playback.invalid/').pathname.toLowerCase();
    if (pathname.endsWith('.mp4')) return 'mp4';
  } catch { /* URLs sem formato reconhecido preservam a seleção HLS legada. */ }
  return 'hls';
}
